import futebol from '../assets/Icons/futebol.png';
import basket from '../assets/Icons/basket.png';
import tennis from '../assets/Icons/tennis.png';

export const icons = {
  futebol: futebol,
  basket: basket,
  tennis: tennis,
};
